/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface RtsSubmissionsListGet$Params {
  fromDate?: string;
  toDate?: string;
  submissionId?: string;
  clientName?: string;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortDir?: string;
}

export function rtsSubmissionsListGet(
  http: HttpClient,
  rootUrl: string,
  params?: RtsSubmissionsListGet$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, rtsSubmissionsListGet.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.query('submissionId', params.submissionId, {});
    rb.query('clientName', params.clientName, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortDir', params.sortDir, {});
  }
  return http
    .request(rb.build({ responseType: 'json', accept: 'application/json', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<any>)
    );
}

rtsSubmissionsListGet.PATH = '/Rts/submissions';
